import React from 'react';
import { useNavigate } from 'react-router-dom';
import { User, LogOut, Settings, Bell } from 'lucide-react';
import AdminSidebar from './AdminSidebar';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import { adminAuthService } from '../../services/admin/adminAuthService';

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();
  const { user, token, logout } = useAdminAuth();

  const handleLogout = async () => {
    try {
      await adminAuthService.logout(token);
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      logout();
      navigate('/admin/login');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#9C8862] via-[#A67C52] to-[#9C8862] shadow-2xl sticky top-0 z-50 border-b-4 border-[#1A1A1A]">
        <div className="max-w-full px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            {/* Logo + Title */}
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center shadow-2xl border-4 border-[#1A1A1A] ring-4 ring-white/30">
                <img 
                  src="https://customer-assets.emergentagent.com/job_5ad4f013-9db1-4f9c-b371-b988a841f7e1/artifacts/nmtmq4a0_%D8%A7%D9%8A%D9%82%D9%88%D9%86%D8%A9%20%D8%A7%D9%84%D8%B4%D8%B9%D8%A7%D8%B1.png"
                  alt="Wazin"
                  className="w-8 h-8 object-contain"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = '<div class="text-[#C8A870] text-lg font-black">W</div>';
                  }}
                />
              </div>
              <div>
                <div className="text-[#1A1A1A] text-sm font-black drop-shadow-lg tracking-wide">منصة وازن القانونية</div>
                <div className="text-[#1A1A1A]/70 text-xs font-semibold tracking-wider">WAZIN ADMIN PANEL</div>
              </div>
            </div>

            {/* User Info */}
            <div className="flex items-center gap-3">
              {/* Notifications */}
              <button
                className="p-2 hover:bg-[#1A1A1A]/10 rounded-lg transition-all relative border border-transparent hover:border-[#1A1A1A]"
                title="الإشعارات"
              >
                <Bell className="w-5 h-5 text-[#1A1A1A]" strokeWidth={2.5} />
                <span className="absolute top-1 right-1 w-2 h-2 bg-red-600 rounded-full shadow-lg ring-2 ring-white"></span>
              </button>

              {/* Settings */}
              <button
                onClick={() => navigate('/admin/settings')}
                className="p-2 hover:bg-[#1A1A1A]/10 rounded-lg transition-all hidden md:block border border-transparent hover:border-[#1A1A1A]"
                title="الإعدادات"
              >
                <Settings className="w-5 h-5 text-[#1A1A1A]" strokeWidth={2.5} />
              </button>

              {/* User Menu */}
              <div className="flex items-center gap-3 border-r-2 border-[#1A1A1A]/20 pr-3">
                {user && (
                  <div className="text-left hidden md:block">
                    <p className="font-black text-sm drop-shadow-lg text-[#1A1A1A]">{user.fullName}</p>
                    <p className="text-xs text-[#1A1A1A]/60 font-semibold">{user.roleName}</p>
                  </div>
                )}
                <div className="w-10 h-10 bg-gradient-to-br from-[#1A1A1A] to-[#2D2D2D] rounded-lg flex items-center justify-center shadow-xl border-2 border-white">
                  <User className="w-5 h-5 text-[#9C8862]" strokeWidth={3} />
                </div>
              </div>

              {/* Logout */}
              <button
                onClick={handleLogout}
                className="p-2 hover:bg-red-600/20 rounded-lg transition-all border border-transparent hover:border-red-600"
                title="تسجيل الخروج"
              >
                <LogOut className="w-5 h-5 text-[#1A1A1A] hover:text-red-600" strokeWidth={2.5} />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content with Sidebar */}
      <div className="flex-1 flex overflow-hidden">
        {/* Sidebar */}
        <AdminSidebar />

        {/* Content Area */}
        <div className="flex-1 overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;